<template>
	<div class="log">
		<span class="font-bold">{{ $moment(date).format('DD.MM.YYYY HH:mm') }} </span>
		<span>{{ message }} </span>
		<span> / {{ author.first_name }} </span>
	</div>
</template>

<script>
export default {
	name: "Log",
	props: {
		date: String,
		message: String,
		author: Object
	}
}
</script>

<style scoped>

</style>